import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import randomstring from 'uuid/v4';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import NavigationPrompt from 'react-router-navigation-prompt';

import Alert from '../../../dialogs/Alert';
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.catalog.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import { BlueTickIcon, AddIcon } from '../../../../images/icons/WrapSvg';

import DownshiftMultiple from '../../../inputs/MultipleInput';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';

import List from './List';
import Dialog from './Item';

function isOk(field) {
    return field === undefined || field.length < 4;
}

function parsePermits(arr) {
    return arr.roles
        .map((r) => {
            return { id: r.id, name: r.nombre, type: 'rol' };
        })
        .concat(
            arr.usuarios.map((r) => {
                return { id: r.id, name: r.nombre, type: 'user' };
            }),
        );
}

function helperText(field, intl) {
    return field === undefined || field.length === 0
        ? intl.formatMessage({ id: 'required' })
        : field.length < 4
        ? intl.formatMessage({ id: 'min_length_4' })
        : '';
}

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-employee"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}

class Catalog extends React.Component {
    state = {
        codigo: randomstring(),
        descripcion: '',
        nombre: '',
        arr_write_permits: [],
        error: '',
        errorType: undefined,
        orden: 'NU',
        valores: [],
        toDelete: [],
        open: false,
        selected: null,
        pending_changes: false,
        catalog: undefined
    };

    static getDerivedStateFromProps(props, state) {
        if (props.catalog !== state.catalog  || props.id !== state.id) {
            state.catalog = props.catalog;
            state.id = props.id;
            console.log(props.catalog, props.id);
            if (props.catalog !== undefined && props.id !== undefined) {
                const {
                    codigo,
                    nombre,
                    descripcion,
                    sistema,
                    orden,
                    valores,
                    permisos,
                } = state.catalog;
                const write =
                    permisos !== undefined && permisos.ed !== undefined
                        ? parsePermits(permisos.ed)
                        : [];

                state.codigo = codigo;
                state.descripcion = descripcion ? descripcion : '';
                state.nombre = nombre ? nombre : '';
                state.sistema = sistema === true ? true : false;
                state.orden = orden === 'AL' ? 'AL' : 'NU';
                state.valores = valores
                    ? valores.sort((a, b) => (a.orden > b.orden ? 1 : -1)).map((i) => i)
                    : [];
                state.toDelete = [];
                state.open = false;
                state.selected = null;
                state.arr_write_permits = write;
            }
            return state;
        }
        return null;
    }

    handleUpdate(state) {
        if (this.isCorrect(state)) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
    }

    isCorrect = (state) => {
        const { nombre, valores, pending_changes } = state;
        return pending_changes && nombre && nombre.length > 3 && valores && valores.length > 0
            ? true
            : false;
    };

    componentWillUnmount() {
        this.props.setTools([]);
    }

    handleChange = (event) => {
        const state = this.state;
        state[event.target.name] = event.target.value;
        state.pending_changes = true;
        this.handleUpdate(state);
        this.setState(state);
    };

    handleChecked = (event) => {
        const state = this.state;
        state[event.target.name] = event.target.checked;
        state.pending_changes = true;
        this.handleUpdate(state);
        this.setState(state);
    };

    handleRadio = (event) => {
        let arr = [...this.state.valores];
        if (event.target.value === 'AL') {
            arr = [].concat(arr).sort((a, b) => (a.valor.trim() < b.valor.trim() ? -1 : 1));
        }

        const state = this.state;
        state.orden = event.target.value;
        state.valores = arr;
        state.pending_changes = true;
        this.handleUpdate(state);
        this.setState(state);
    };

    handleEdit = (item) => {
        this.setState({ open: true, selected: item });
    };

    handleAdd = (event) => {
        this.setState({ open: true, selected: null });
    };

    handleClose = (name, score) => {

        const { selected, orden, pending_changes } = this.state;
        let arr = [...this.state.valores];
        let pending = pending_changes;
        if (name) {
            if (selected) {
                const index = arr.indexOf(selected);
                selected.valor = name;
                selected.puntuacion = score;
                arr.splice(index, 1, selected);
            } else {
                arr.push({
                    id: randomstring(),
                    orden: arr.length,
                    puntuacion: score,
                    valor: name,
                });
            }
            if (orden === 'AL') {
                arr = [].concat(arr).sort((a, b) => (a.valor.trim() < b.valor.trim() ? -1 : 1));
            }
            pending = true;
        }

        const state = this.state;
        state.open = false;
        state.selected = null;
        state.valores = arr;
        state.pending_changes = pending;
        this.handleUpdate(state);
        this.setState(state);
    };

    handleDelete = (item) => {
        const arr = [...this.state.valores];
        const index = arr.indexOf(item);
        const arrDelete = [...this.state.toDelete];
        arrDelete.push(item.id);
        arr.splice(index, 1);
        
        const state = this.state;
        state.valores = arr;
        state.pending_changes = true;
        state.toDelete = arrDelete;
        this.handleUpdate(state);
        this.setState(state);
    };

    // a little function to help us with reordering the result
    reorder = (startIndex, endIndex) => {
        const result = Array.from(this.state.valores);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        this.setState({ valores: result, pending_changes: true });
    };

    handleSummit = () => {
        const {
            codigo,
            nombre,
            descripcion,
            arr_write_permits,
            valores,
            toDelete,
            orden,
        } = this.state;
        const catalogo = {
            codigo: codigo,
            nombre: nombre,
            descripcion: descripcion,
            orden: orden,
            permisos: {
                ed: this.getPermits(arr_write_permits),
            },
            valores: valores,
        };
        this.setState({ pending_changes: false });
        if (!this.props.id) {
            this.props
                .addCatalog(catalogo)
                .then((r) => {
                    console.log(r);
                    this.props.history.push('/manage/catalogs');
                })
                .catch((error) => {
                    this.setState({ error: error.message.trim(), errorType: error.type });
                    var intervalId = setInterval(this.timer, 5000);
                    this.setState({ intervalId: intervalId });
                });
        } else {
            this.props
                .editCatalog(catalogo, toDelete)
                .then((r) => {
                    console.log(r);
                    this.props.history.push('/manage/catalogs');
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ error: error.message.trim(), errorType: error.type });
                    var intervalId = setInterval(this.timer, 5000);
                    this.setState({ intervalId: intervalId });
                });
        }
    };

    getPermits = (arr) => {
        return {
            jerarquias: [],
            roles: arr
                .filter((f) => f.type === 'rol')
                .map((m) => {
                    return { id: m.id, nombre: m.name };
                }),
            usuarios: arr
                .filter((f) => f.type === 'user')
                .map((m) => {
                    return { id: m.id, nombre: m.name };
                }),
        };
    };

    handleUpdatePermits = (name, values) => {
        this.setState({
            [name]: values,
            pending_changes: true,
        });
    };

    handleTooltipClose = () => {
        this.setState({ error: undefined });
    };

    timer = () => {
        this.setState({ error: undefined });
        clearInterval(this.state.intervalId);
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const {
            nombre,
            descripcion,
            arr_write_permits,
            orden,
            valores,
            open,
            selected,
            error,
            errorType,
            pending_changes,
        } = this.state;
        const { catalog, catalog_is_loading, catalog_has_error, intl, info } = this.props;
        console.log(error, errorType)
        if (catalog_has_error.hasErrored) {
            return <Error open message={catalog_has_error.error} handleClose={this.handleBack} />;
        } else if (catalog === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_catalog_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            const suggestions =
                info !== undefined && info.security !== undefined
                    ? info.security.suggestions
                    : undefined;
            return (
                <div
                    className={'flex_full_column padding_bottom_9 padding_top_12 margin_bottom_48'}
                >
                    <NavigationPrompt when={(crntLocation, nextLocation) => pending_changes}>
                        {({ onConfirm, onCancel }) => (
                            <Alert
                                title="alert_dialog_discard_title"
                                text="alert_dialog_discard_message"
                                open={true}
                                onCancel={onCancel}
                                onConfirm={onConfirm}
                            />
                        )}
                    </NavigationPrompt>
                    {catalog === undefined && catalog_is_loading && <Loading open opacity />}
                    <div className={'flex_full_column padding_borders'}>
                        <TextField
                            autoFocus={true}
                            fullWidth
                            id={'nombre'}
                            name={'nombre'}
                            required
                            error={isOk(nombre)}
                            helperText={helperText(nombre, intl)}
                            label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                            className={'flex_full_row'}
                            value={nombre}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            id={'descripcion'}
                            name={'descripcion'}
                            required
                            label={intl.formatMessage({ id: 'form_field_description' })}
                            className={'flex_full_row'}
                            value={descripcion}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                        <div
                            className={
                                'flex_full_row barlow_semibold padding_top_24 c_dark_grey_blue'
                            }
                        >
                            <FormattedMessage id="form_field_edition_permits" />
                        </div>
                        <DownshiftMultiple
                            id="write_permits"
                            label={intl.formatMessage({ id: 'form_field_user_roles_hierarchies' })}
                            suggestions={suggestions}
                            value={arr_write_permits}
                            name="arr_write_permits"
                            onChange={this.handleUpdatePermits}
                        />
                        <div className="flex_full_row margin_top_32 align_center">
                            <div className="c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="sortBy" />
                            </div>
                            <Radio
                                checked={orden === 'NU'}
                                onChange={this.handleRadio}
                                value="NU"
                                name="radio-button-demo"
                                aria-label="A"
                            />
                            <div className="c_dark_grey_blue barlow_regular_textwrap">
                                <FormattedMessage id="manual" />
                            </div>
                            <Radio
                                checked={orden === 'AL'}
                                onChange={this.handleRadio}
                                value="AL"
                                name="radio-button-demo"
                                aria-label="A"
                            />
                            <div className="c_dark_grey_blue barlow_regular_textwrap">
                                <FormattedMessage id="alpha" />
                            </div>
                        </div>
                        <div className="flex_full_row margin_top_32 align_center">
                            <List
                                items={valores}
                                alpha={orden === 'AL'}
                                handleEdit={this.handleEdit.bind(this)}
                                handleDelete={this.handleDelete.bind(this)}
                                reorder={this.reorder.bind(this)}
                            />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleAdd.bind(this)}
                            >
                                <AddIcon />
                            </Fab>
                            {open && (
                                <Dialog item={selected} handleClose={this.handleClose.bind(this)} />
                            )}
                            {error && (
                                <Snackbar
                                    open={true}
                                    variant={ errorType ? errorType  :  "error" }
                                    text={error}
                                    onClose={this.handleTooltipClose}
                                />
                            )}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Catalog.propTypes = {
    intl: intlShape.isRequired,
    catalog_is_loading: PropTypes.bool.isRequired,
    catalog_has_error: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        catalog: state.catalog,
        catalog_is_loading: state.catalog_is_loading,
        catalog_has_error: state.catalog_has_error,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Catalog)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/catalog/Catalog.js